export const PERSISTENCE_KEYS = Object.freeze({
  LAYOUT_WIDTHS: Object.freeze({
    MESSAGE_CENTER: 'message-center-layout-width',
    SEARCH_PROJECTS: 'search-projects-layout-width',
    SOURCING: 'sourcing-layout-width'
  }),
  PROFILE_TABS: Object.freeze({
    CANDIDATES: 'profile-tabs-order-for-candidates',
    COMPANIES: 'profile-tabs-order-for-companies',
    CONTACTS: 'profile-tabs-order-for-contacts',
    HIRING_AUTHORITIES: 'profile-tabs-order-for-hiring-authorities',
    JOB_ORDERS: 'profile-tabs-order-for-job-orders'
  }),
  AI: {
    ASSISTANT_POSITION: 'ai-assistant-position'
  },
  SENDOUTS: {
    ACTIVITY_LOGS: 'sendouts-activity-logs'
  },
  TABLES: Object.freeze({
    AI_PROSPECTING_ASSISTANT_RESULTS: 'ai-prospecting-assistant-results',
    AI_PROSPECTING_ASSISTANT_COMPANY_RESULTS: 'ai-prospecting-assistant-company-results'
  })
});
